import type { NarrativeSection } from "../types/narrative";

export interface TOCSection {
  id: string;
  label: string;
  icon?: string;
}

/**
 * Extract TOC-displayable sections from narrative sections
 * Filters out intro and table_of_contents, and sections without labels
 */
export function extractTOCSections(
  narrativeSections: NarrativeSection[],
): TOCSection[] {
  return narrativeSections
    .filter(
      (section) =>
        Boolean(section.label) &&
        section.id !== "table_of_contents" &&
        section.id !== "intro",
    )
    .map((section) => ({
      id: section.id,
      label: section.label as string,
      icon: section.icon,
    }));
}
